const types = {
  SET_LISTA_UNIDADES_PROCEDENCIA: 'SET_LISTA_UNIDADES_PROCEDENCIA',
  SHOW_GLOBAL_LOADING: 'ui/SHOW_GLOBAL_LOADING',
  HIDE_GLOBAL_LOADING: 'ui/HIDE_GLOBAL_LOADING',
  SHOW_SNACKBAR: 'ui/SHOW_SNACKBAR',
  HIDE_SNACKBAR: 'ui/HIDE_SNACKBAR'
}

export default types



// WEBPACK FOOTER //
// ./src/vuex/relatorios/mutations-types.js